


















































import { Component, Vue } from "vue-property-decorator";
import footerCom from "../components/footer/index.vue";
@Component({
  components: {
    footerCom,
  },
})
export default class Home extends Vue {
  public type = 1;
  public gameId = 0;
  public bdVid: any = "";
  public boxUrl = "";

  public mounted() {
    this.type = Number(this.$route.query.type);
    this.gameId = Number(this.$route.query.gameId);
    if (this.type == 1) {
      this.boxUrl =
        "https://static.dhsf.996box.com/box/channel_app/996boxV340SetupSigned1697521204@6087.exe";
    }
    if (this.type == 2) {
      this.boxUrl =
        "https://static.dhsf.996box.com/box/channel_app/996boxV340SetupSigned1697521136@6088.exe";
    }
    if (this.type == 3) {
      this.boxUrl =
        "https://static.dhsf.996box.com/box/channel_app/996boxV340SetupSigned@6089.exe";
    }
  }

  // 下载文件，自定义文件名称
  public downFile() {
    let filename = "";
    if (this.type == 1 && this.gameId) {
      filename = this.gameId
        ? `996boxV340SetupSigned'web2detail,id=${this.gameId}'@6087.exe`
        : "996boxV340SetupSigned@6087.exe";
    }
    if (this.type == 2 && this.gameId) {
      filename = this.gameId
        ? `996boxV340SetupSigned'web2detail,id=${this.gameId}'@6088.exe`
        : "996boxV340SetupSigned@6088.exe";
    }
    if (this.type == 3 && this.gameId) {
      filename = this.gameId
        ? `996boxV340SetupSigned'web2detail,id=${this.gameId}'@6089.exe`
        : "996boxV340SetupSigned@6089.exe";
    }
    this.$Message.info("下载中, 请勿走开哦");
    const x = new XMLHttpRequest();
    x.open("GET", this.boxUrl, true);
    x.responseType = "blob";
    x.onload = () => {
      const hrefUrl = window.URL.createObjectURL(x.response);
      const a = document.createElement("a");
      a.href = hrefUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };
    x.send();
  }
}
